import {Text, View} from 'native-base';
import React from 'react';

import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';
import {Reservation, ReservationDate} from 'models/Reservations';

import ReservationListItem from './ReservationListItem/ReservationListItem';
import {useTheme} from 'styled-components/native';

export interface ReservationDatesSelectorProps {
  reservationDates: ReservationDate[];
  onReservationPress: (reservation: Reservation) => void;
  selectedReservationConfirmationCode: string | undefined;
}

const ReservationDatesSelector: React.FC<
  ReservationDatesSelectorProps
> = props => {
  const {
    reservationDates,
    onReservationPress,
    selectedReservationConfirmationCode,
  } = props;
  const theme = useTheme();
  const {paleSky} = theme.colors;

  const {trackAdobeEvent} = useTrackEvent();

  return (
    <View flexDirection="column" align-items="stretch">
      <Text
        margin="auto"
        paddingY={5}
        color={paleSky}
        fontSize={2}
        letterSpacing={'0.86px'}>
        Filter offers by reservation dates
      </Text>
      {reservationDates &&
        reservationDates.map((reservation, index) => (
          <ReservationListItem
            key={`reservationFilterListItem-${index}`}
            reservation={reservation}
            selected={
              reservation.confirmationCode ===
              selectedReservationConfirmationCode
            }
            onPress={() => {
              onReservationPress(reservation);
              trackAdobeEvent({
                event: AdobeEvent.click,
                click: {name: 'rewards filter dates my reservation'},
              });
            }}
          />
        ))}
    </View>
  );
};

export default ReservationDatesSelector;
